'use client';

import MetricLineChart from '../MetricLineChart';
import MetricAreaChart from '../MetricAreaChart';
import MetricBarChart from '../MetricBarChart';

// Sample data: Cost per user over time
const costPerUserData = [
  { name: 'Jan', costPerUser: 4.80, users: 5000 },
  { name: 'Feb', costPerUser: 4.50, users: 6200 },
  { name: 'Mar', costPerUser: 4.10, users: 7800 },
  { name: 'Apr', costPerUser: 3.85, users: 9500 },
  { name: 'May', costPerUser: 3.60, users: 11200 },
  { name: 'Jun', costPerUser: 3.45, users: 13000 },
];

// Sample data: Cost breakdown by service
const costBreakdownData = [
  { name: 'Compute', cost: 15000, percentage: 43 },
  { name: 'Database', cost: 8500, percentage: 24 },
  { name: 'Storage', cost: 5200, percentage: 15 },
  { name: 'Network', cost: 3800, percentage: 11 },
  { name: 'Other', cost: 2500, percentage: 7 },
];

// Sample data: Stacked area for cost breakdown over time
const stackedCostData = [
  { name: 'Jan', Compute: 12000, Database: 6500, Storage: 4000, Network: 2800, Other: 1800 },
  { name: 'Feb', Compute: 13500, Database: 7200, Storage: 4500, Network: 3200, Other: 2000 },
  { name: 'Mar', Compute: 14200, Database: 7800, Storage: 4800, Network: 3400, Other: 2100 },
  { name: 'Apr', Compute: 15000, Database: 8200, Storage: 5000, Network: 3600, Other: 2300 },
  { name: 'May', Compute: 15500, Database: 8500, Storage: 5100, Network: 3700, Other: 2400 },
  { name: 'Jun', Compute: 15000, Database: 8500, Storage: 5200, Network: 3800, Other: 2500 },
];

export function CloudCostPerUserTrend() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📉 Cost per User Improvement</h3>
      <MetricLineChart
        data={costPerUserData}
        lines={[
          { dataKey: 'costPerUser', name: 'Cost per User ($)', color: '#E89841' },
        ]}
        xAxisLabel="Month"
        yAxisLabel="Cost per User ($)"
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing cost per user decreasing from $4.80 to $3.45 as user base grew
        from 5K to 13K users. This 28% reduction demonstrates economies of scale and successful
        optimization efforts. Continue monitoring as you scale to maintain this trend.
      </p>
    </div>
  );
}

export function CloudCostStackedArea() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">💰 Cost Breakdown Over Time</h3>
      <MetricAreaChart
        data={stackedCostData}
        areas={[
          { dataKey: 'Compute', name: 'Compute', color: '#E89841' },
          { dataKey: 'Database', name: 'Database', color: '#4A90E2' },
          { dataKey: 'Storage', name: 'Storage', color: '#6FCF97' },
          { dataKey: 'Network', name: 'Network', color: '#F2C94C' },
          { dataKey: 'Other', name: 'Other', color: '#9B59B6' },
        ]}
        xAxisLabel="Month"
        yAxisLabel="Cost ($)"
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Total cloud spend growing steadily but linearly with user base. Compute remains the
        largest component (43%). June shows compute costs stabilizing despite user growth,
        indicating successful optimization. Database costs as percentage of total remain stable.
      </p>
    </div>
  );
}

export function CloudCostByService() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🔍 Current Month Cost Breakdown</h3>
      <MetricBarChart
        data={costBreakdownData}
        bars={[
          { dataKey: 'cost', name: 'Monthly Cost ($)', color: '#E89841' },
        ]}
        xAxisLabel="Service Type"
        yAxisLabel="Cost ($)"
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Compute ($15K, 43%) is the primary cost driver, followed by Database ($8.5K, 24%).
        Consider: right-sizing instances, using spot/reserved instances for compute, and
        optimizing database queries to reduce costs further. Storage and network costs are
        well-optimized relative to usage.
      </p>
    </div>
  );
}
